import { motion } from 'framer-motion';
import { createStyles } from '@mantine/core';
import BreadCrumbCompo from '../components/breadcrumbs/breadcrumbs-component';
import FormValidationCompo from '../components/form/form-component';
import JumboTron2 from '../components/jumbotron-2/jumbotron2-component';

const useStyle = createStyles((theme) => ({
  title: {
    marginTop: 10,
    marginBottom: 10,
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: 24,
    fontWeight: 700,
    color: '#4D4D4D',
    textAlign: 'center',
    '@media (max-width: 600px)': {
      marginTop: 10,
      marginBottom: 10,
      textAlign: 'left',
    },
  },
}));
const JoinUsPage = () => {
  const { classes } = useStyle();
  return (
    <motion.div>
      <BreadCrumbCompo />
      <div className="container">
        <h1 className={classes.title}>Form Jadi Agen</h1>
      </div>
      <FormValidationCompo />
      <JumboTron2 />
    </motion.div>
  );
};

export default JoinUsPage;
